import { getUnique, keyBy } from '../../../helpers/common'
import { SCORE_MODE_ID } from '../constant'
import { TYPE_LOGICAL_OPERATOR } from '../store/sliceScoreLevel'
import { TYPE_PERIOD } from './constant'

export const getIdsUnique = (data, key) => {
  return Array.from(new Set(data.map((item) => item[`${key}`])))
}

export const dataScoreLevel = (data) => {
  const ids = getIdsUnique(data, `modelId`)
  const obj = {}

  ids.forEach((id) => {
    obj[id] = data.filter((item) => item.modelId === id)
  })
  return obj
}

export const handleDataProvince = (data) => {
  return data.filter((item) => item.level === 4)
}

export const convertTreeData = (dataArr) => {
  const data = keyBy(
    dataArr.map((e) => ({ ...e, children: {} })),
    'id',
  )

  dataArr
    .slice()
    .reverse()
    .forEach((e) => {
      if (data[e.parentId]) {
        data[e.parentId].children[e.id] = data[e.id]
        delete data[e.id]
      }
    })

  return data
}

//handle SelectCheckBox
export const handleSelectCheckBox = (prevList, valueNew) => {
  if ([...prevList].map((key) => key.value).includes(valueNew.value)) {
    return prevList.filter((item) => item.value !== valueNew.value)
  }
  return [...prevList, valueNew]
}

//
export const covertTagDataIndustry = (listData, listId) => {
  let arr = []
  listId.forEach((item) => {
    arr.push({
      label: listData[item]?.name,
      value: listData[item]?.id,
    })
  })
  return arr
}

//handle data business Age
export const handleDataBusinessAge = (data) => {
  const newData = data
    .filter((key) => key.analysisIndicatorTypeLevel === 2)
    .map((item) => ({
      label: item.analysisIndicatorTypeName,
      value: item.analysisIndicatorTypeId,
    }))
  return newData
}

export const getCurrentTime = () => {
  return new Date().getTime()
}

export const handelGetAllPort = (data) => {
  return data.map((item) => ({
    label: item.portfolioName,
    value: item.portfolioId,
  }))
}

export const convertListId = (data) => [...data].map((item) => item.value)

export const handelDefaultSetting = (data, allPortId) => {
  const settingPortIds = handelConvertToArrayNumber(data.portfolioId)
  return {
    ...data,
    portfolioId: allPortId.filter((id) => settingPortIds.includes(id)),
    bussinessAgeId: handelConvertToArrayNumber(data.bussinessAgeId),
    bussinessSizeId: handelConvertToArrayNumber(data.bussinessSizeId),
    excludeId: handelConvertToArrayNumber(data.excludeId),
    industryId: handelConvertToArrayNumber(data.industryId),
    provinceId: handelConvertToArrayNumber(data.provinceId),
    scoreLevelObj: JSON.parse(data.scoreLevelObj),
  }
}
export const handelDefaultParamsSetting = (data, allPortId) => {
  const settingPortIds = handelConvertToArrayNumber(data.portfolioId)
  return {
    currency: data.currency,
    portfolioIds: allPortId.filter((id) => settingPortIds.includes(id)),
    bussinessAgeIds: handelConvertToArrayNumber(data.bussinessAgeId),
    bussinessSizeIds: handelConvertToArrayNumber(data.bussinessSizeId),
    excludeIds: handelConvertToArrayNumber(data.excludeId),
    industryIds: handelConvertToArrayNumber(data.industryId),
    provinceIds: handelConvertToArrayNumber(data.provinceId),
    scoreLevel: JSON.parse(data.scoreLevelObj),
  }
}
export const convertDataSettingToFilter = (data) => {
  return {
    currency: data.currency,
    portfolioId: data.portfolioIds,
    bussinessAgeId: data.bussinessAgeIds,
    bussinessSizeId: data.bussinessSizeIds,
    excludeId: data.excludeIds,
    industryId: data.industryIds,
    provinceId: data.provinceIds,
    scoreLevelObj: data.scoreLevel,
  }
}

export const handelConvertToArrayNumber = (data) => {
  return data ? data.split(',').map(Number) : []
}

//handelConvertDataPortById
export const handelConvertDataTagById = (data, listAll) => {
  if (!listAll || !Array.isArray(listAll)) {
    return []
  }
  const dataArray = Array.isArray(data) ? data : []
  return listAll.filter((item) => dataArray.includes(item.value))
}

export const handleDataProvinceImport = (data) =>
  data.map((item) => ({
    label: item.name,
    value: item.id,
  }))

export const convertDataIndustryImport = (data) =>
  data.map((item) => ({
    label: item.name,
    value: item.id,
  }))

//convert data score level
export const convertListIdFiinGateToObj = (data) => {
  const obj = {}
  data.forEach((item) => {
    obj[item] = true
  })
  return obj
}

export const convertListScoreCustom = (data) => {
  const obj = {}
  data.forEach((item) => {
    if (item?.From !== null && item?.To !== null) {
      obj[getUnique()] = {
        From: item?.From ? item.From : undefined,
        To: item?.To ? item.To : undefined,
      }
    }
  })
  return obj
}

export const convertDataScoreLevelApi = (data) => {
  const {
    CurrentCreditRiskScore,
    CurrentPerformanceScore,
    PreviousCreditRiskScore,
    PreviousPerformanceScore,
    LogicalOperator,
    PeriodType,
  } = data

  return {
    logicalOperator: Object.values(TYPE_LOGICAL_OPERATOR).find(
      (item) => item.value === LogicalOperator,
    ),
    typePeriod:
      TYPE_PERIOD.find((item) => item.value === PeriodType) || TYPE_PERIOD[0],
    creditScore: {
      current: {
        fiinGate: convertListIdFiinGateToObj(
          CurrentCreditRiskScore.ListLevelScoreChecked,
        ),
        custom: convertListScoreCustom(CurrentCreditRiskScore.ListCustomRanges),
      },
      previous: {
        fiinGate: convertListIdFiinGateToObj(
          PreviousCreditRiskScore.ListLevelScoreChecked,
        ),
        custom: convertListScoreCustom(
          PreviousCreditRiskScore.ListCustomRanges,
        ),
      },
    },

    performanceScore: {
      current: {
        fiinGate: convertListIdFiinGateToObj(
          CurrentPerformanceScore.ListLevelScoreChecked,
        ),
        custom: convertListScoreCustom(
          CurrentPerformanceScore.ListCustomRanges,
        ),
      },
      previous: {
        fiinGate: convertListIdFiinGateToObj(
          PreviousPerformanceScore.ListLevelScoreChecked,
        ),
        custom: convertListScoreCustom(
          PreviousPerformanceScore.ListCustomRanges,
        ),
      },
    },
  }
}

//
export const convertDataNameOrgById = (data) => {
  return data.map((item) => ({
    label: item.organizationName,
    value: item.organizationId,
  }))
}

//covert display score
export const handleDisplayScore = (scoreRange, data) => {
  let arr = []
  let undetermined = false
  //fiinGate
  const fiinGateIds = Object.keys(data.fiinGate)
    .filter((item) => data.fiinGate[item])
    .map(Number)
  const rangeScoreFiin = scoreRange.filter((item) =>
    fiinGateIds.includes(item.scoreRangeId),
  )

  rangeScoreFiin.forEach((item) => {
    const {
      modelId,
      scoreRange_Min: min,
      scoreRange_Max: max,
      scoreRangeName,
    } = item || {}
    if (modelId === SCORE_MODE_ID.CORPORATE_RISK) {
      if (
        min !== null &&
        min !== undefined &&
        max !== null &&
        max !== undefined
      ) {
        for (let i = min; i <= max; i++) {
          arr.push(i)
        }
      } else {
        undetermined = scoreRangeName
      }
    } else {
      if (min && max) {
        for (let i = min; i <= max; i++) {
          arr.push(i)
        }
      }
      if (min === 0 && max === 0) {
        undetermined = scoreRangeName
      }
    }
  })
  //custom
  Object.values(data.custom).forEach((item) => {
    const from = item?.From ? Number(item.From) : null
    const to = item?.To ? Number(item.To) : null

    if (from !== null && to !== null) {
      for (let i = from; i <= to; i++) {
        arr.push(i)
      }
    } else if (from !== null) {
      for (let i = from; i <= 1000; i++) {
        arr.push(i)
      }
    } else if (to !== null) {
      for (let i = 1; i <= to; i++) {
        arr.push(i)
      }
    }
  })

  //remove the same value
  const arrFormat = [...new Set(arr.map(Number))].sort((a, b) => a - b)
  let range = arrFormat[0]
  let arrRange = []

  arrFormat.forEach((item, index) => {
    if (item + 1 !== arrFormat[index + 1]) {
      if (!range && !item) {
        arrRange.push(`0`)
      } else {
        arrRange.push(`${range}-${item}`)
      }
      range = arrFormat[index + 1]
    }
  })

  return {
    rangeScore: undetermined
      ? [...arrRange, undetermined]?.toString()
      : arrRange?.toString(),
    isShow:
      arrRange?.toString() === '' && undetermined === false
        ? false
        : arrRange?.toString() === '0-1000' && undetermined
        ? false
        : true,
  }
}
